function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDEDED"
    },
    d: "M465.735,416.386H46.265c-20.357,0-37.012-16.655-37.012-37.012V132.627 c0-20.357,16.655-37.012,37.012-37.012h419.47c20.357,0,37.012,16.655,37.012,37.012v246.747 C502.747,399.73,486.092,416.386,465.735,416.386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8DA"
    },
    d: "M465.735,95.614h-61.687c20.357,0,37.012,16.655,37.012,37.012v246.747 c0,20.357-16.655,37.012-37.012,37.012h61.687c20.357,0,37.012-16.655,37.012-37.012V132.627 C502.747,112.27,486.092,95.614,465.735,95.614z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.253,
    y: 169.639,
    style: {
      fill: "#88888F"
    },
    width: 493.494,
    height: 74.024
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.06,
    y: 169.639,
    style: {
      fill: "#797781"
    },
    width: 61.687,
    height: 74.024
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E07188"
    },
    cx: 95.614,
    cy: 330.024,
    r: 37.012
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F8E99B"
    },
    cx: 144.964,
    cy: 330.024,
    r: 37.012
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88888F"
    },
    d: "M431.807,314.602H234.41c-5.11,0-9.253-4.142-9.253-9.253c0-5.111,4.143-9.253,9.253-9.253h197.398 c5.111,0,9.253,4.142,9.253,9.253C441.06,310.461,436.919,314.602,431.807,314.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88888F"
    },
    d: "M407.133,351.614H234.41c-5.11,0-9.253-4.142-9.253-9.253s4.143-9.253,9.253-9.253h172.723 c5.111,0,9.253,4.142,9.253,9.253S412.244,351.614,407.133,351.614z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E2D31"
    },
    d: "M502.747,160.381c-0.032,0-0.063,0.005-0.095,0.005H120.289c-5.11,0-9.253,4.142-9.253,9.253 c0,5.111,4.143,9.253,9.253,9.253h373.205v55.518H18.506v-55.518h64.771c5.11,0,9.253-4.142,9.253-9.253 c0-5.111-4.143-9.253-9.253-9.253H18.506v-27.759c0-15.306,12.452-27.759,27.759-27.759h419.47 c15.306,0,27.759,12.453,27.759,27.759c0,5.111,4.142,9.253,9.253,9.253c5.111,0,9.253-4.142,9.253-9.253 c0-25.511-20.754-46.265-46.265-46.265H46.265C20.754,86.361,0,107.115,0,132.627v246.747c0,25.511,20.754,46.265,46.265,46.265 h419.47c25.511,0,46.265-20.754,46.265-46.265V169.639v-0.005C512,164.523,507.858,160.381,502.747,160.381z M465.735,407.133 H46.265c-15.307,0-27.759-12.453-27.759-27.759V252.916h474.988v126.458C493.494,394.679,481.041,407.133,465.735,407.133z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.1cc90b40046d03c671fe7a876a6710e0.svg";
export { ForwardRef as ReactComponent };